import React from 'react'
import injectSheet from 'react-jss'

const styles = {
	root: {
		outline: 'none',
		backgroundColor: 'rgba(0,0,0,0)',
		color: 'white',
		fontSize: 14,
		textAlign: 'center',
		border: 'none',
		textTransform: 'uppercase',
		height: 48,
		minWidth: 64,
		padding: [[6, 8]],
	},
	innerBox: {
		'&:hover': {
			backgroundColor: 'rgba(0,0,0,.12)',
			borderColor: 'gray',
			color: 'gray',
		},
		minWidth: 64,
		height: 34,
		lineHeight: '34px',
		padding: [[0, 8]],
		border: props => props.border ? [[1, 'white', 'solid']] : 'none',
	},
}

const Button = ({classes, children}) => (
	<button className={classes.root}>
		<div className={classes.innerBox}>
			{ children }
		</div>
	</button>
)

Button.defaultProps = {
	border: false,
}

export default injectSheet(styles)(Button)



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx